import API from "../services/api-request.js";

export default {
  data() {
    return {
      tourCategory: "",
      restoCategory: "",
      type: "",
      validity: "",
      price: "",
      description: "",
    };
  },
  methods: {
    addTourCategory() {
      API.store({ type: this.tourCategory }, "tour-category").then(
        (response) => {
          //# alert success
          this.$swal.fire({
            position: "top-end",
            icon: "success",
            title: "Categorie ajouté avec succès",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      );
    },

    addRestoCategory() {
      API.store({ name: this.restoCategory }, "resto-category").then(
        (response) => {
          //# alert success
          this.$swal.fire({
            position: "top-end",
            icon: "success",
            title: "Categorie ajouté avec succès",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      );
    },
    addType() {
      API.store(
        {
          name: this.type,
          validity: this.validity,
          price: this.price,
          description: this.description,
        },
        "substype"
      ).then((response) => {
        //# alert success
        this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "Type d'abonnement ajouté avec succès",
          showConfirmButton: false,
          timer: 1500,
        });
      });
    },
    goToTourCategories() {
      this.$router.push(`/category/${"tour"}`);
    },
    goToRestoCategories() {
      this.$router.push(`/category/${"resto"}`);
    },
    goToSubsTypes() {
      this.$router.push(`/category/${"substypes"}`);
    },
  },
  mounted() {},
};
